module.exports = __webpack_public_path__ + "static/img/logo-2.db27ec8.svg";